import { AfterViewInit, Input, Directive} from "@angular/core";
import { LookupService } from "../services/lookup.service";
import { NdmsSafeSubscriber } from "./ndms-safe-subscriber";

@Directive()
export class BaseViewComponent extends NdmsSafeSubscriber implements AfterViewInit  {
    @Input() readOnly:boolean;
    constructor(protected lookupService: LookupService) {
        super();
    }

    getLookup(lookupDataSetName, extraValues?: any) {
        let lookup: any[] = Object.assign([], this.lookupService.get(lookupDataSetName));
        if (extraValues) {
            if (extraValues.length > 0) {
                for (let ii of extraValues) {
                    lookup.push(ii);
                }
            } else {
                lookup.push(extraValues);
            }
        }
        return lookup;
    }

    getLookupValue(lookupDataSetName, id) {
        let value = this.lookupService.getLookupValue(lookupDataSetName, id);
        return (value && value.display) ? value.display.trim() || '' : '';
    }

    getLookupId(lookupDataSetName, display) {
        let value = this.lookupService.getLookupId(lookupDataSetName, display);
        return (value) ? value.id || -1 : -1;
    }

    ngAfterViewInit(): void {
    }
}